/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";

export default class VikatanNews extends React.Component {
  render() {
    return (
      <div className={styles["amp-first-grid"]}>
        <div className={styles["amp-section"]}>
          <h5 className={styles["footer-title"]}>
            <span>vikatan News</span>
          </h5>
          <ul>
            <Link href="https://www.vikatan.com/news">
              <h5>செய்திகள்</h5>
            </Link>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/latest-news">
                {" "}
                <span>லேட்டஸ்ட்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/news/india">
                {" "}
                <span>இந்தியா</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/news/tamilnadu">
                {" "}
                <span>தமிழ்நாடு</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/news/world">
                {" "}
                <span>உலகம்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/business">
                {" "}
                <span>வணிகம்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/news/environment">
                {" "}
                <span>சுற்றுச்சூழல்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/technology">
                {" "}
                <span>தொழில்நுட்பம்</span>
              </Link>{" "}
            </li>
          </ul>

          <ul>
            <Link href="https://cinema.vikatan.com/">
              <h5>சினிமா</h5>
            </Link>
            <li>
              {" "}
              <Link href="https://cinema.vikatan.com/tamil-cinema">
                {" "}
                <span>தமிழ் சினிமா</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://cinema.vikatan.com/bollywood">
                {" "}
                <span>இந்திய சினிமா</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://cinema.vikatan.com/hollywood">
                {" "}
                <span>ஹாலிவுட் சினிமா</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://cinema.vikatan.com/movie-review">
                {" "}
                <span>சினிமா விமர்சனம்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://cinema.vikatan.com/television">
                {" "}
                <span>சின்னத்திரை</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/topics/television-serial">
                {" "}
                <span>மெகா சீரியல்கள்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/topics/web-series">
                {" "}
                <span>வெப் சீரிஸ்</span>
              </Link>{" "}
            </li>
          </ul>

          <ul>
            <Link href="https://www.vikatan.com/spiritual">
              <h5>ஆன்மிகம்</h5>
            </Link>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/spiritual/temples">
                {" "}
                <span>திருத்தலங்கள்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/topics/mahaan">
                {" "}
                <span>மகான்கள்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/topics/festival">
                {" "}
                <span>விழாக்கள்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/horoscope/rasipalan">
                {" "}
                <span>ராசிபலன்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/horoscope/gurupeyarchi">
                {" "}
                <span>குருப்பெயர்ச்சி</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/horoscope/sanipeyarchi">
                {" "}
                <span>சனிப்பெயர்ச்சி</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/spiritual/astrology">
                {" "}
                <span>ஜோதிடம்</span>
              </Link>{" "}
            </li>
          </ul>

          <ul>
            <Link href="https://www.vikatan.com/business">
              <h5>வணிகம்</h5>
            </Link>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/business/share-market">
                {" "}
                <span>பங்குச் சந்தை</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/topics/mutual-fund">
                {" "}
                <span>மியூச்சுவல் ஃபண்ட்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/business/real-estate">
                {" "}
                <span>ரியல் எஸ்டேட்</span>
              </Link>{" "}
            </li>
            <li>
              {" "}
              <Link href="https://www.vikatan.com/business/career">
                {" "}
                <span>வேலை வாய்ப்பு</span>
              </Link>{" "}
            </li>
          </ul>
        </div>
        <div>
          <h5 className={styles["footer-title"]}>
            <span>Useful Links</span>
          </h5>
          <ul>
            <li>
              <Link href="https://www.vikatan.com/collection/kids-stories" target="_blank">
                Tamil stories for kids
              </Link>
            </li>
            <li>
              <Link
                href="https://cinema.vikatan.com/tamil-cinema/breaking-a-film-before-ponniyin-selvan-for-mani-ratnam-inbox"
                target="_blank"
              >
                Ponniyin selvan movie
              </Link>
            </li>
            <li>
              <Link href="https://www.vikatan.com/topics" target="_blank">
                Vikatan news topics
              </Link>
            </li>
            <li>
              <Link
                href="https://www.vikatan.com/health/healthy/112609-health-benefits-of-black-cumin-seeds"
                target="_blank"
              >
                Karunjeeragam uses
              </Link>
            </li>
            <li>
              <Link href="https://www.vikatan.com/horoscope/gurupeyarchi" target="_blank">
                Guru peyarchi date
              </Link>
            </li>
            <li>
              <Link href="https://www.vikatan.com/live-updates/coronavirus" target="_blank">
                Live corona updates
              </Link>
            </li>
            <li>
              <Link href="https://www.vikatan.com/news/banking/pros-and-cons-of-bank-mergers" target="_blank">
                Bank merger pros and cons
              </Link>
            </li>
            <li>
              <Link
                href="https://www.vikatan.com/business/money/138405-mutual-fund-investments-for-monthly-returns"
                target="_blank"
              >
                Mutual funds monthly returns
              </Link>
            </li>
            <li>
              <Link href="https://www.vikatan.com/live-updates/gold-rate-chennai-today" target="_blank">
                Gold rate in chennai today
              </Link>
            </li>
            <li>
              <Link href="https://www.vikatan.com/live-updates/silver-rate-chennai-today" target="_blank">
                Silver rate in chennai today
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export { VikatanNews };
